// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9i-0";
export var optionCard = "_9i-1";